<template>
	<b-container fluid class="mt-5 p-0">
		<b-card no-body>
			<b-card-header class="container-fluid">
				<b-row>
					<b-col xl="6" md="6">
						<div class="h3">Manage Mobile Data Plans</div>
					</b-col>
					<b-col xl="6" md="6" class="text-right">
						<b-button size="sm" variant="success" v-on:click="addNewMobileDataPlanOpen"
							>Add New Mobile Data Plan</b-button
						>
					</b-col>
				</b-row>
			</b-card-header>
		</b-card>

		<div class="mt-4">
			<div class="text-center w-100">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="loadingStatus"
				></b-icon>
			</div>
			<div class="mb-3" v-if="!loadingStatus">
				<b-row>
					<b-col cols="12" xl="8" lg="7" md="7" sm="6">
						<b-form-group
							label=""
							label-for="per-page-select"
							label-cols-sm="0"
							label-cols-md="0"
							label-cols-lg="0"
							label-align-sm="center"
							class="mb-2 per-page-select"
						>
						<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
						<b-form-select
							id="per-page-select"
							class="diameter-report-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
							v-on:input="changePageOption(perPage)"
						></b-form-select>
						</b-form-group>
					</b-col>

					<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
						<b-form-group
							label=""
							label-for="filter-input"
							label-align-sm="right"
							label-size="sm "
							class="mb-0 per-page-select"
						>
							<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
							<b-input-group size="sm">
								<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<div class="">
					<b-table
						striped
						hover
						:items="tableData"
						:fields="tableColumns"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:filter-included-fields="filterOn"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						:sort-direction="sortDirection"
						head-variant="light"
						table-class="text-nowrap"
						class="data-management-table primary-table"
						sticky-header="true"
						thead-class="white"
						show-empty
						responsive
						small
						@sort-changed="headerColumnChanged"
						@filtered="onFiltered"
					>
						<template #cell(action)="row">
							<span>
								<i
									class="fas fa-trash-alt cursor-pointer text-danger"
									v-on:click="deleteMobileDataInfo(row.item.id, row.item.name)"
								></i>
							</span>
						</template>
					</b-table>
				</div>
				<b-row class="mt-4">
					<b-col >
						<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
					</b-col>
					<b-col >
						<b-pagination
							class="flex-fill-custom pr-4 ml-3 justify-content-end"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</div>
		</div>

		<b-modal
			centered
			size="lg"
			id="mobile-data-plan"
			hide-footer
			title="Data Plan"
			class="mobile-data-plan"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<MobileDataPlan></MobileDataPlan>
		</b-modal>
	</b-container>
</template>

<script>
import administratorService from "../../../../common/api-services/administrator-service";
import swal from "sweetalert2";
import MobileDataPlan from "../../../Components/Mobile-Data-Plan";
import handleResponse from "../../../../common/directive/handlResponse";
import pagination from '../../../../common/format/pagination'

export default {
	name: "MobileDataPlans",
	components: {
		MobileDataPlan,
	},
	data() {
		return {
			loadingStatus: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			tableColumns: [
				{key: "id", label: "CEL Plan ID", sortable: true, sortDirection: "desc"},
				{key: "name", label: "Name", sortable: true, sortDirection: "desc"},
				{key: "description", label: "Description", sortable: true, sortDirection: "desc"},
				{key: "action", label: "", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			loadingNum: 1,
			paginationLoadingBar: true,
		};
	},
	mounted() {
		this.getTotalRows();
		this.getMobileDataPlansFunc();
		this.$root.$on("manageMobileDataPlan", res => {
			if (res) {
				this.getMobileDataPlansFunc();
			}
		});
	},
	methods: {
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		headerColumnChanged(e) {
			this.sortBy = e.sortBy;
			if (e.sortDesc === true) {
				this.sortDirection = "asc";
			} else {
				this.sortDirection = "desc";
			}
			this.getTopOffPlansFunc();
		},

		getMobileDataPlansFunc() {
			this.loadingStatus = true;
			administratorService.getMobileDataPlans().then(res => {
				this.tableData = res;
				this.loadingStatus = false;
				if (res) {
					this.totalRows = this.tableData.length;
					this.getTotalRows();
				}
			});
		},

		addNewMobileDataPlanOpen() {
			this.$bvModal.show("mobile-data-plan");
		},

		changePageOption(page) {
			this.getTotalRows();
		},

		deleteMobileDataInfo(id, name) {
			swal.fire({
				title: `Data Plan Information`,
				text: `Delete selected Data Plan? ${name}`,
				buttonsStyling: false,
				showCloseButton: true,
				showCancelButton: true,

				confirmButtonText: "Delete",
				cancelButtonText: "Cancel",
				//cancelButtonClass: 'btn btn-danger',
			}).then(result => {
				if (result.isConfirmed) {
					administratorService.deleteDataPlan(id).then(res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type})
						this.getMobileDataPlansFunc();
					});
				}
			});
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},
	},
};
</script>
